import React, { useEffect, useState } from 'react';

interface TextCyclerProps {
  texts: string[];
  delayBetweenStrings: number;
  className?: string;
}

export const TextCycler = ({ texts, delayBetweenStrings, className }: TextCyclerProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex < texts.length - 1) {
        setCurrentIndex((prevIndex) => prevIndex + 1);
      } else {
        clearInterval(intervalId);
      }
    }, delayBetweenStrings);

    return () => {
      clearInterval(intervalId);
    };
  }, [texts, delayBetweenStrings, currentIndex]);

  return (
    <div className={className}>
      <span>{texts[currentIndex]}</span>
    </div>
  );
};
